// extracted by mini-css-extract-plugin
export default {"loader":"LoadingFallback_loader__ZLGzN","rotation":"LoadingFallback_rotation__XGsoj","rotationBack":"LoadingFallback_rotationBack__MM-ys"};